import { useQuery } from 'hooks/useCustomQuery';
import getAvailableTrunkTypes from 'API/TrunkTypes/getAvailableTrunkTypes';
import getSRTTrunkTypesForServiceProfile from 'API/SRT/getSRTTrunkTypesForServiceProfile';
import { multiSelectDataMapper } from 'utils/utils';

/**
 * Trunk types available to an SRT service profile.
 *
 * Same split as SBCaaS: partner level has an SRT-scoped endpoint, wholesaler
 * level only has the platform-agnostic list, so callers narrow that result to
 * the SRT trunk type themselves.
 *
 * @param {object} params
 * @param {string} params.level     `partner` or `wholesaler`.
 * @param {string} params.partnerID Owning partner, used at partner level only.
 */
const useGetSRTProfileTrunkTypes = ({ level, partnerID }) => {
    return useQuery({
        queryKey: ['srtTrunkTypes', level, partnerID],
        queryFn: async () => {
            const result =
                level === 'partner'
                    ? await getSRTTrunkTypesForServiceProfile(partnerID)
                    : await getAvailableTrunkTypes();
            return result.data.map(multiSelectDataMapper);
        },
    });
};

export default useGetSRTProfileTrunkTypes;
